if (!customElements.get('kalangi-refinement')) {
  customElements.define('kalangi-refinement', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.root = document.getElementById(this.dataset.rootId);
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-kf-open]');
      this.status = this.querySelector('[data-kf-status]');
      this.fields = this.querySelector('[data-kf-fields]');
      this.applyButton = this.querySelector('[data-kf-apply]');
      this.retained = this.querySelector('[data-kf-retained]');
      this.min = this.querySelector('[data-kf-min]');
      this.max = this.querySelector('[data-kf-max]');
      this.sort = this.querySelector('[data-kf-sort]');
      this.gallery = this.querySelector('[data-kg-dialog]');
      if (this.gallery) {
        this.syncPreviewSelection();
        this.galleryHandler = event => this.openGallery(event.detail.radio);
        this.root.addEventListener('kalangi:preview', this.galleryHandler);
        this.gallery.querySelector('[data-kg-close]').addEventListener('click', () => this.gallery.close());
        this.gallery.querySelector('[data-kg-retry]').addEventListener('click', () => this.openGallery(this.galleryRadio));
        this.gallery.addEventListener('close', () => {
          this.galleryView?.abort();
          this.restoreGalleryScroll?.();
          if (this.isConnected) this.galleryRadio?.focus({ preventScroll: true });
        });
        this.gallery.addEventListener('click', event => {
          if (event.target !== this.gallery) return;
          const rect = this.gallery.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.gallery.close();
        });
      }
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('[data-kf-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.restoreScroll?.();
        this.trigger.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.querySelector('[data-kf-retry]').addEventListener('click', () => this.load());
      this.querySelectorAll('[data-kf-reset], [data-kf-clear]').forEach(button => button.addEventListener('click', () => this.reset()));
      this.applyButton.addEventListener('click', () => {
        if (this.apply()) this.dialog.close();
      });
      this.fields.addEventListener('input', event => {
        if (event.target === this.min && Number(this.min.value) > Number(this.max.value)) this.min.value = this.max.value;
        if (event.target === this.max && Number(this.max.value) < Number(this.min.value)) this.max.value = this.min.value;
        this.preview();
      });
      this.root.addEventListener('change', event => {
        if (event.target.matches('.block-additional-siblings-radio')) { this.selectionNotice(); this.syncPreviewSelection(); }
      });
      this.root.querySelector('[data-clear-radio]')?.addEventListener('click', () => { this.selectionNotice(); this.syncPreviewSelection(); });
      const ready = () => {
        if (!this.root.kalangiCarousel) return;
        this.carousel = this.root.kalangiCarousel;
        this.trigger.hidden = false;
        if (!this.scrollHandler && this.root.dataset.sourceCollection) {
          this.scrollHandler = () => this.loadMoreOnScroll();
          this.carousel.swiper.on('slideChange', this.scrollHandler);
          this.slider = this.root.querySelector('[data-slider-instance]');
          this.slider?.addEventListener('pointerdown', this.scrollHandler, { passive: true });
          this.slider?.addEventListener('focusin', this.scrollHandler);
        }
      };
      this.root.addEventListener('kalangi:ready', ready);
      ready();
    }

    syncPreviewSelection() {
      this.root.dataset.previewSelectedHandle = this.root.querySelector('.block-additional-siblings-radio:checked')?.dataset.productHandle || '';
    }

    async openGallery(radio) {
      if (!radio || !this.gallery || !radio.checked || this.dialog.open) return;
      this.galleryRadio = radio;
      this.carousel?.swiper.autoplay?.stop();
      const status = this.gallery.querySelector('[data-kg-status]');
      this.gallery.querySelector('[data-kg-title]').textContent = radio.dataset.productTitle;
      this.gallery.querySelector('[data-kg-retry]').hidden = true;
      this.gallery.querySelector('[data-kg-stage]').hidden = true;
      this.gallery.querySelector('[data-kg-controls]').hidden = true;
      this.gallery.querySelector('[data-kg-thumbnails]').replaceChildren();
      status.textContent = this.gallery.dataset.loading;
      if (!this.gallery.open) {
        const overflow = document.documentElement.style.overflow;
        this.restoreGalleryScroll = () => { document.documentElement.style.overflow = overflow; };
        document.documentElement.style.overflow = 'hidden';
        this.gallery.showModal();
      }
      try {
        const module = await import(this.dataset.galleryScript);
        if (!this.isConnected || !this.gallery.open) return;
        this.galleryView ||= new module.KalangiGallery(this);
        await this.galleryView.show(radio);
      } catch (error) {
        if (!this.isConnected || !this.gallery.open || error.name === 'AbortError') return;
        status.textContent = this.gallery.dataset.error;
        this.gallery.querySelector('[data-kg-retry]').hidden = false;
      }
    }

    disconnectedCallback() {
      this.root.removeEventListener('kalangi:preview', this.galleryHandler);
      this.galleryView?.abort();
      if (this.gallery?.open) this.gallery.close();
      this.restoreGalleryScroll?.();
      this.carousel?.swiper.off('slideChange', this.scrollHandler);
      this.slider?.removeEventListener('pointerdown', this.scrollHandler);
      this.slider?.removeEventListener('focusin', this.scrollHandler);
      this.controller?.abort();
      this.restoreScroll?.();
      this.initialised = false;
      this.scrollHandler = null;
    }

    async loadMoreOnScroll() {
      if (this.extending || this.scrollComplete || this.applied || this.dialog.open || !this.isConnected) return;
      const swiper = this.carousel.swiper;
      if (swiper.destroyed) return;
      const visible = Math.ceil(Number(swiper.params.slidesPerView) || 3);
      if (swiper.activeIndex + visible < swiper.slides.length - 6) return;
      this.extending = true;
      const slider = this.root.querySelector('[data-slider-instance]');
      slider.setAttribute('aria-busy', 'true');
      try {
        await this.load();
        if (!this.items || !this.isConnected || swiper.destroyed || this.applied) return;
        const wrapper = slider.querySelector('.swiper-wrapper');
        const shown = new Set([...wrapper.children].map(node => node.dataset.handle));
        const pending = this.items.filter(item => !shown.has(item.product.handle));
        const batch = pending.slice(0, 12);
        if (batch.length) {
          const position = swiper.activeIndex;
          swiper.appendSlide(batch.map(item => this.card(item)));
          swiper.update();
          swiper.slideTo(position, 0, false);
          await new Promise(resolve => requestAnimationFrame(() => {
            if (!swiper.destroyed) swiper.slideTo(position, 0, false);
            requestAnimationFrame(resolve);
          }));
        }
        this.scrollComplete = pending.length <= batch.length;
      } finally {
        slider.removeAttribute('aria-busy');
        this.extending = false;
      }
    }

    card(item) {
      if (!item.node) item.node = this.carousel.build(this.cardTemplate, item.cardProduct);
      return item.node;
    }

    async open() {
      if (!this.carousel) return;
      this.carousel.swiper.autoplay?.stop();
      this.restoreInputs();
      const previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.restoreScroll = () => { document.documentElement.style.overflow = previousOverflow; };
      this.dialog.showModal();
      await this.load();
    }

    load() {
      if (!this.loadPromise) {
        this.loadPromise = this.loadCatalogue().finally(() => { this.loadPromise = null; });
      }
      return this.loadPromise;
    }

    async loadCatalogue() {
      if (this.items) return this.preview();
      if (this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      this.status.textContent = this.status.dataset.loading;
      this.querySelector('[data-kf-retry]').hidden = true;
      try {
        const products = [];
        let page = 1;
        let pages = 1;
        do {
          const url = new URL(`${window.Shopify?.routes?.root || '/'}collections/${encodeURIComponent(this.root.dataset.sourceCollection || 'kalangi')}`, location.origin);
          url.searchParams.set('view', 'vhalam-kalangi-data');
          url.searchParams.set('page', String(page));
          const response = await fetch(url.href, { headers: { Accept: 'text/html' }, credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error(`Kalangi catalogue: ${response.status}`);
          const data = await response.json();
          if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 1) throw new Error('Invalid Kalangi catalogue');
          products.push(...data.products);
          pages = data.pages;
          page += 1;
        } while (page <= pages);
        const wrapper = this.root.querySelector('.swiper-wrapper');
        const existing = new Map([...wrapper.children].filter(node => node.matches('.swiper-slide')).map(node => [node.dataset.handle, node]));
        const template = wrapper.querySelector('.swiper-slide');
        if (!template) throw new Error('Kalangi card unavailable');
        this.cardTemplate = template.cloneNode(true);
        const defaultHandle = this.root.dataset.defaultHandle;
        const used = new Set();
        this.items = products.filter(item => {
          const product = item.product;
          if (!product?.handle || used.has(product.handle) || product.handle === this.root.dataset.currentHandle) return false;
          if (this.root.dataset.hideSoldOut === 'true' && !product.variants.some(variant => variant.available)) return false;
          used.add(product.handle);
          return true;
        }).map(item => {
          const product = item.product;
          const variant = product.variants.find(option => option.available) || product.variants[0];
          const cardProduct = { ...product, variants: product.variants.map(option => ({ ...option, price: option.price / 100, compare_at_price: option.compare_at_price == null ? null : option.compare_at_price / 100 })) };
          return { ...item, price: variant.price, node: existing.get(product.handle) || null, cardProduct };
        });
        for (const [handle, node] of existing) {
          if (used.has(handle)) continue;
          const radio = node.querySelector('.block-additional-siblings-radio');
          this.items.push({ product: { handle }, collections: [], colours: [], price: Number(radio?.dataset.price || 0), node });
        }
        this.items.sort((a, b) => Number(b.product.handle === defaultHandle) - Number(a.product.handle === defaultHandle));
        this.renderColours();
        const prices = this.items.map(item => item.price / 100);
        this.priceBounds = { min: Math.min(...prices), max: Math.max(...prices) };
        [this.min, this.max].forEach(input => {
          input.min = String(this.priceBounds.min);
          input.max = String(this.priceBounds.max);
          input.step = prices.every(Number.isInteger) ? '1' : '0.01';
          input.disabled = this.priceBounds.min === this.priceBounds.max;
        });
        this.restoreInputs();
        this.fields.disabled = false;
        this.applyButton.disabled = false;
        this.preview();
      } catch (error) {
        this.items = null;
        this.status.textContent = this.status.dataset.error;
        this.querySelector('[data-kf-retry]').hidden = false;
        console.warn('Kalangi filters could not load: ' + String(error));
      } finally {
        this.loading = false;
      }
    }

    renderColours() {
      const colours = new Map();
      this.items.forEach(item => item.colours.forEach(colour => {
        if (colour.id && colour.label) colours.set(colour.id, colour);
      }));
      const container = this.querySelector('[data-kf-colours]');
      container.replaceChildren();
      [...colours.values()].sort((a, b) => a.label.localeCompare(b.label)).forEach(colour => {
        const label = document.createElement('label');
        label.className = 'kalangi-refinement__choice';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = colour.id;
        input.setAttribute('aria-label', colour.label);
        input.dataset.kfColour = '';
        const text = document.createElement('span');
        const swatch = document.createElement('i');
        swatch.className = 'kalangi-refinement__swatch';
        swatch.setAttribute('aria-hidden', 'true');
        if (/^#[0-9a-f]{3,8}$/i.test(colour.hex || '')) swatch.style.setProperty('--kf-colour', colour.hex);
        text.append(swatch, document.createTextNode(colour.label));
        label.append(input, text);
        container.append(label);
      });
    }

    values() {
      return {
        collections: [...this.querySelectorAll('[data-kf-collection]:checked')].map(input => input.value),
        colours: [...this.querySelectorAll('[data-kf-colour]:checked')].map(input => input.value),
        min: Number(this.min.value) <= this.priceBounds.min ? '' : this.min.value,
        max: Number(this.max.value) >= this.priceBounds.max ? '' : this.max.value,
        sort: this.sort.value
      };
    }

    restoreInputs() {
      const state = this.applied || { collections: [], colours: [], min: '', max: '', sort: 'featured' };
      this.querySelectorAll('[data-kf-collection]').forEach(input => { input.checked = state.collections.includes(input.value); });
      this.querySelectorAll('[data-kf-colour]').forEach(input => { input.checked = state.colours.includes(input.value); });
      if (this.priceBounds) {
        this.min.value = state.min === '' ? String(this.priceBounds.min) : state.min;
        this.max.value = state.max === '' ? String(this.priceBounds.max) : state.max;
      }
      this.sort.value = state.sort;
      if (this.items) this.preview();
    }

    matches(state) {
      const low = state.min === '' ? 0 : Number(state.min) * 100;
      const high = state.max === '' ? Infinity : Number(state.max) * 100;
      return this.items.filter(item =>
        (!state.collections.length || state.collections.some(handle => item.collections.includes(handle))) &&
        (!state.colours.length || item.colours.some(colour => state.colours.includes(colour.id))) &&
        item.price >= low && item.price <= high
      ).sort((a, b) => state.sort === 'price-asc' ? a.price - b.price : state.sort === 'price-desc' ? b.price - a.price : 0);
    }

    preview() {
      if (!this.items || !this.priceBounds) return;
      this.updatePriceSlider();
      const state = this.values();
      this.status.textContent = this.status.dataset.count.replace('[count]', String(this.matches(state).length));
      return true;
    }

    updatePriceSlider() {
      const low = Number(this.min.value);
      const high = Number(this.max.value);
      const span = this.priceBounds.max - this.priceBounds.min;
      const position = price => span ? ((price - this.priceBounds.min) / span) * 100 : 0;
      const range = this.querySelector('[data-kf-range]');
      range.style.setProperty('--kf-low', position(low) + '%');
      range.style.setProperty('--kf-high', position(high) + '%');
      this.min.style.zIndex = position(low) > 90 ? '3' : '1';
      const money = new Intl.NumberFormat(this.dataset.locale || 'en-IN', { style: 'currency', currency: this.dataset.currency || 'INR', maximumFractionDigits: 2 });
      const lowLabel = money.format(low);
      const highLabel = money.format(high);
      this.querySelector('[data-kf-min-value]').textContent = lowLabel;
      this.querySelector('[data-kf-max-value]').textContent = highLabel;
      this.min.setAttribute('aria-valuetext', lowLabel);
      this.max.setAttribute('aria-valuetext', highLabel);
    }

    apply() {
      if (!this.items || !this.preview()) return false;
      const state = this.values();
      const matches = this.matches(state);
      this.scrollComplete = true;
      const shown = new Set(matches);
      const swiper = this.carousel.swiper;
      const selected = this.root.querySelector('.block-additional-siblings-radio:checked');
      swiper.removeAllSlides();
      this.items.forEach(item => { if (item.node) this.retained.append(item.node); });
      if (matches.length) swiper.appendSlide(matches.map(item => this.card(item)));
      if (selected) selected.checked = true;
      swiper.update();
      swiper.slideTo(0, 0);
      const slider = this.root.querySelector('[data-slider-instance]');
      slider.hidden = matches.length === 0;
      this.querySelector('[data-kf-empty]').hidden = matches.length > 0;
      this.applied = state;
      const count = state.collections.length + state.colours.length + Number(state.min !== '' || state.max !== '') + Number(state.sort !== 'featured');
      const badge = this.querySelector('[data-kf-badge]');
      badge.textContent = String(count);
      badge.hidden = count === 0;
      this.querySelector('[data-kf-results]').hidden = count === 0;
      this.querySelector('[data-kf-result-count]').textContent = this.status.dataset.count.replace('[count]', String(matches.length));
      this.shown = shown;
      this.selectionNotice();
      return true;
    }

    selectionNotice() {
      const selected = this.retained.querySelector('.block-additional-siblings-radio:checked');
      this.querySelector('[data-kf-selection]').hidden = !selected;
    }

    reset() {
      this.applied = null;
      this.restoreInputs();
      if (this.items) this.apply();
    }
  });
}
